module.exports = __webpack_public_path__ + "static/img/materialsInfo6.197e3fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo6.png
// module id = fJUY
// module chunks = 2